type NotificationIconProps = {
  variant: 'on' | 'off' | 'timer';
  size?: number;
};

export default function NotificationIcon({ variant, size = 16 }: NotificationIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"
      focusable="false" style={{ flexShrink: 0 }}>
      {variant === 'timer' ? (
        <>
          <circle cx="12" cy="13" r="8" />
          <path d="M12 9v4l3 2M9 2h6M12 2v3" />
        </>
      ) : variant === 'off' ? (
        <>
          <path d="m3 3 18 18M10 4.3A6 6 0 0 1 18 10c0 1.2.1 2.2.4 3.2M6.3 6.3A6 6 0 0 0 6 10c0 5-3 7-3 7h14M10 21h4" />
        </>
      ) : (
        <path d="M18 10a6 6 0 0 0-12 0c0 5-3 7-3 7h18s-3-2-3-7M10 21h4" />
      )}
    </svg>
  );
}
